module.exports = __webpack_public_path__ + "static/media/us.da3ae027.jpg";